import React from 'react';

export default class MainComponent extends React.Component {
  render(){
    return (
      <React.Fragment>
        <div className="title">
          Gebruikers
        </div>
        <div className="melding">In dit scherm kun je gebruikers aanmaken en wijzigen.</div>
      </React.Fragment>
    )
  }
}
